import { Component, OnInit } from '@angular/core';

export interface performanceData {
  id: number;
  imagePath: string;
  uname: string;
  productName: string;
  budget: number;
  priority: string;
}

const ELEMENT_DATA: performanceData[] = [
  {
    id: 1,
    imagePath: 'assets/images/users/1.jpg',
    uname: 'Sunil Joshi',
    productName: 'Elite Admin',
    budget: 3.9,
    priority: 'low'
  },
  {
    id: 2,
    imagePath: 'assets/images/users/2.jpg',
    uname: 'Andrew McDownland',
    productName: 'Real Homes Theme',
    budget: 24.5,
    priority: 'medium'
  },
  {
    id: 3,
    imagePath: 'assets/images/users/3.jpg',
    uname: 'Christopher Jamil',
    productName: 'MedicalPro Theme',
    budget: 12.8,
    priority: 'high'
  },
  {
    id: 4,
    imagePath: 'assets/images/users/4.jpg',
    uname: 'Nirav Joshi',
    productName: 'Hosting Press HTML',
    budget: 2.4,
    priority: 'critical'
  },
  {
    id: 5,
    imagePath: 'assets/images/users/5.jpg',
    uname: 'Micheal Doe',
    productName: 'Helping Hands',
    budget: 9.3,
    priority: 'moderate'
  },
];

@Component({
  selector: 'app-performance-table',
  templateUrl: './performance-table.component.html',
  styleUrls: ['./performance-table.component.scss']
})
export class PerformanceTableComponent implements OnInit {

  displayedColumns: string[] = ['assigned', 'name', 'priority', 'budget'];
  dataSource = ELEMENT_DATA;

  constructor() { }

  ngOnInit(): void {
  }

}
